import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 20px;

  @media (max-width: 640px) {
    padding: 10px;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

export const PixSuccessTitle = styled.h1`
  font-size: 28px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin: 0 0 8px 0;
`;

export const PixSuccessSubtitle = styled.p`
  font-size: 16px;
  color: #6b7280;
  text-align: center;
  margin: 0 0 24px 0;
`;

export const PixTimerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 16px;
  color: #4b5563;

  span {
    font-weight: 500;
  }
`;

export const PixTimerDisplay = styled.div`
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
  font-family: monospace;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  min-width: 80px;
  text-align: center;
`;

export const PixCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 32px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
`;

export const PixStatusHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 3px solid #e5e7eb;
  border-top-color: #0b6856;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const PixStatusText = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #4b5563;
  margin: 0;
`;

export const QRCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
`;

export const QRCodePlaceholder = styled.div`
  border: 3px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

export const QRCode = styled.img`
  width: 100%;
`;

export const PixButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 24px 0;
`;

export const PixCompactButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: white;
  color: #0b6856;
  border: 2px solid #0b6856;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  width: auto;
  min-width: 200px;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    background: #f0fdf4;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(11, 104, 86, 0.2);
  }
`;

export const PixPrimaryButton = styled.button`
  padding: 14px 32px;
  background: #16a34a;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  width: auto;
  min-width: 200px;

  &:hover {
    background: #15803d;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
  }
`;

export const ApprovalTime = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: #dcfce7;
  border-radius: 8px;
  margin: 24px 0 16px 0;

  span {
    color: #16a34a;
    font-weight: 600;
    font-size: 14px;
  }
`;

export const ApprovalIcon = styled.div`
  width: 22px;
  height: 22px;
  background: #16a34a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
`;

export const PixInstructions = styled.div`
  margin: 32px 0 24px 0;
`;

export const InstructionsTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 16px;
`;

export const InstructionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InstructionItem = styled.p`
  font-size: 14px;
  color: #4b5563;
  margin: 0;
  line-height: 1.6;
`;

export const PixCodeBox = styled.div`
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #f3f4f6;
    border-color: #0b6856;
  }
`;

export const PixCodeLabel = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 8px 0;
  font-weight: 600;
`;

export const PixCodeText = styled.p`
  font-size: 11px;
  color: #000;
  margin: 0;
  word-break: break-all;
  font-family: monospace;
  line-height: 1.6;
`;
